module.exports = __webpack_public_path__ + "img/content9-3.06cb7253.webp";